import { textBlockBlueprint } from "@made-people/blueprint-text-block/blueprint";

textBlockBlueprint.override({
  slots: {
    base: "flex flex-col gap-3",
    headingWrapper: "",
    body: "max-w-[800px]",
    truncateButton: "text-label-md w-fit underline underline-offset-4",
    ctaWrapper: "flex flex-row gap-3 items-bottom mt-3",

    // Markdown Slots
    ul: "list-[disc] pl-6 mb-3 last:mb-0",
    ol: "list-[decimal] pl-6 mb-3 last:mb-0",
    li: "",
    span: "text-body-sm lg:text-body-md",
    p: "text-body-sm lg:text-body-md mb-3 last:mb-0",
    h1: "text-heading-xl mt-[0.7em] mb-[0.4em] first:mt-0 last:mb-0 lg:text-heading-xl font-secondary",
    h2: "text-heading-lg mt-[0.7em] mb-[0.4em] first:mt-0 last:mb-0 lg:text-heading-lg font-secondary",
    h3: "text-heading-md mt-[0.7em] mb-[0.4em] first:mt-0 last:mb-0 lg:text-heading-md font-secondary",
    h4: "text-heading-sm mt-[0.7em] mb-[0.4em] first:mt-0 last:mb-0 lg:text-heading-md",
    h5: "",
    h6: "",
    blockquote: "",
    hr: "",
    a: "underline underline-offset-4 cursor-pointer",
    strong: "font-medium",
    em: "",
    code: "",
    img: "",
    table: "",
    thead: "",
    tbody: "",
    tr: "",
    th: "",
    td: "",
    pre: "",
  },
  variants: {
    spacing: {
      true: {
        base: "max-w-[750px]",
      },
      false: {
        base: "",
      },
    },
    layout: {
      none: {
        base: "flex flex-col gap-4 items-start",
        headingWrapper: "text-left font-bold max-w-[400px]",
        body: "text-left",
        ctaWrapper: "justify-self-start flex flex-row gap-2 mt-4",
      },
      vertical: {
        base: "flex flex-col gap-4",
        body: "max-w-component-max-w-md",
        ctaWrapper: "mt-3",
      },
      twoColumn: {
        base: "w-full grid grid-cols-12 grid-rows-[max-content_max-content_max-content] gap-x-3 lg:gap-x-5 items-start",
        headingWrapper:
          "col-start-1 col-span-6 text-left row-start-1 row-end-4 mb-0",
        body: "col-start-7 col-span-6 row-start-1 row-end-2 text-left mb-0",
        truncateButton:
          "col-start-7 col-span-6 justify-self-start row-start-2 row-end-3 mt-0 no-underline",
        ctaWrapper:
          "flex flex-row gap-4 col-start-7 col-span-6 row-start-2 row-end-3 mt-4",
      },
      centered: {
        base: "flex flex-col gap-4 items-center max-w-[750px]",
        headingWrapper: "text-center font-bold max-w-[400px]",
        body: "text-center",
        ctaWrapper: "justify-self-center flex flex-row gap-2 mt-4",
      },
    },
  },
  defaultVariants: {
    spacing: "true",
    layout: {
      initial: "vertical",
      lg: "vertical",
    },
  },
});
